import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import DashBoardLayerOne from "../components/DashBoardLayerOne";
import UnitCountSeven from "../components/child/UnitCountSeven";
import Dashboard from "../components/DashboardLayer";
const HomePageOne = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout >

        {/* Breadcrumb */}
        <Breadcrumb title="Over All" />

        <Dashboard />
        {/* DashBoardLayerOne */}
        {/* <DashBoardLayerOne /> */}

      </MasterLayout>
    </>
  );
};

export default HomePageOne;
